// extracted by mini-css-extract-plugin
module.exports = {"navigatorContainer":"navigator_navigatorContainer__I5JTq","navigatorGlobal":"navigator_navigatorGlobal__2rzia"};